import React from 'react';
import styled from 'styled-components';

const ResourcesContainer = styled.div`
    position: relative;
    width: 1280px;
  padding: 20px;
  background-color: #f8f7f6;
`;

const Paragraph = styled.p`
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
`;

const Title = styled.h2`
  font-size: 20px;
  color: #000;
  margin-bottom: 20px;
`;

const Link = styled.a`
  color: #1155cc;
  text-decoration: underline;
`;

const RecommendedResources = () => {
  return (
    <ResourcesContainer>
      <Title>RECOMMENDED RESOURCES</Title>
      <Paragraph>
        We curate a free, searchable directory of over 5000 mom-recommended and community-vetted resources called <Link href="https://www.themamahood.co/the-m-list/discover">The M List</Link>.
      </Paragraph>
    </ResourcesContainer>
  );
};

export default RecommendedResources;
